import { useModals } from 'almanac-ui/Modal'
import { Presser } from 'components/ContentType/ContentType'
import { ContentTypeProps } from 'components/ContentType/Types'
import { ASPECT_RATIOS, AspectRatioKey, DesignChannels } from 'components/NewFileModal/Types'
import { Wizard } from 'components/Wizards/WizardsDrawer/WizardsDrawerV4/Types'
import { PropsWithChildren } from 'react'
import { DesktopWizardProps, FlowKey, FlowWizards } from '../Types'
import { desktopDesignSchemas } from 'components/Wizards/schemas/desktopSchemas'
import { FlowA2 } from '../Flows/FlowA2/FlowA2'
import { FlowB } from '../Flows/FlowB/FlowB'
import { FlowC } from '../Flows/FlowC/FlowC'
import { usePaywallGuard } from 'hooks/usePaywallGuard'

export type WizardOpenerProps = Omit<ContentTypeProps, 'type'> & {
  type: Wizard
}

export const WizardOpener = (props: PropsWithChildren<WizardOpenerProps>) => {
  const { children, type, initialValues, ...rest } = props
  const { openModal } = useModals()
  const flow = FlowWizards[type as AspectRatioKey]
  const contentType = DesignChannels[type as AspectRatioKey]
  const schema = desktopDesignSchemas[contentType]
  const { width, height } = ASPECT_RATIOS[type as AspectRatioKey]

  const params = {
    schema: schema,
    initialValues: {
      width,
      height,
      ...initialValues,
    },
    ...rest,
  } as DesktopWizardProps

  const handlePress = () => {
    if (!schema) return

    if (flow === FlowKey.A2) {
      openModal(FlowA2, params)
    }

    if (flow === FlowKey.B) {
      openModal(FlowB, params)
    }

    if (flow === FlowKey.C) {
      openModal(FlowC, params)
    }
  }

  const guardedhandlePress = usePaywallGuard(handlePress)

  return (
    <Presser onPress={guardedhandlePress} preventFocusOnPress>
      {children}
    </Presser>
  )
}
